import { AssetItemProps } from '@design-system/asset-item';

import { ctaBlockMapper } from '~/mappers/ctaBlock';
import { headingBlockMapper } from '~/mappers/headingBlock';
import { imageMapper } from '~/mappers/image';
import { ImageConfig } from '~/mappers/image/models';

import { AssetItem } from './models';

export const assetItemMapper = (
  { heading, align, tag, ctaBlocks, image, variant }: AssetItem,
  imageConfig: ImageConfig,
  horizontalView: boolean | null
): AssetItemProps =>
  ({
    headingBlock: headingBlockMapper(heading),
    mediaVariant: variant,
    isHorizontal: horizontalView ?? false,
    // TODO: consider handle image as GatsbyImage
    image: imageMapper({ ...image, ...imageConfig }),
    ...(align && { align }),
    ...(tag && { tag }),
    ...(ctaBlocks.length && { ctaBlock: ctaBlockMapper(ctaBlocks) }),
  } as AssetItemProps);
